/* Mobile product page first screen — see assets/mobile-pdp.css.
   html[data-mobile-pdp] is set by the inline script in snippets/product-template.liquid
   ('compact' | 'sticky'; 'split' is resolved there to one of control/compact/sticky per visitor). */
(function () {
  'use strict';

  var root = document.documentElement;
  var variant = root.getAttribute('data-mobile-pdp-variant'); // control | compact | sticky
  var layout = root.getAttribute('data-mobile-pdp'); // unset for control
  var phone = window.matchMedia('(max-width: 767px)');

  // Analytics: tag the page view with the layout it saw (control too), so add-to-cart
  // rate can be split by variant in GA4 (custom dimension) or any dataLayer consumer.
  if (variant) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'mobile_pdp_layout', mobile_pdp_layout: variant, mobile_pdp_phone: phone.matches });
    } catch (e) {}
  }
  if (!layout) return;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- A) compact ---------------- */

  function collapseFrameSelector() {
    $$('.pdp-content frame-selector').forEach(function (fs) {
      if (fs.dataset.mpdpBound) return;
      fs.dataset.mpdpBound = '1';
      fs.classList.add('mpdp-collapsed');
      var row = $('.frame-selector__label-row', fs);
      if (!row) return;
      row.setAttribute('role', 'button');
      row.setAttribute('tabindex', '0');
      row.setAttribute('aria-expanded', 'false');
      function open() {
        if (!fs.classList.contains('mpdp-collapsed')) return;
        fs.classList.remove('mpdp-collapsed');
        row.setAttribute('aria-expanded', 'true');
        row.removeAttribute('role');
        row.removeAttribute('tabindex');
        updateChat();
      }
      row.addEventListener('click', open);
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });
    });
  }

  function addWallChip() {
    var wallBtn = $('.pdp-content [data-wall-open]');
    var host = $('.pdp-media .product-media-slider'); // position: relative in the theme
    if (!wallBtn || !host || $('.mpdp-wall-chip', host)) return;
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'mpdp-wall-chip';
    chip.innerHTML = wallBtn.innerHTML; // same icon as the button in the buy box
    var wp = wallBtn.closest('wall-preview');
    var label = chip.querySelector('span');
    if (wp && wp.dataset.shortLabel && label) {
      label.textContent = wp.dataset.shortLabel; // short label fits on the image
      chip.setAttribute('aria-label', wallBtn.textContent.trim());
    }
    chip.addEventListener('click', function () { wallBtn.click(); });
    host.appendChild(chip);
  }

  // Fit the gallery so Add to cart ends inside the first screen (min 220px, max = the
  // theme's own slide height). Measured once (and after web fonts), not on scroll, so the
  // in-app/Safari toolbar collapsing never makes the gallery jump.
  var MIN_GALLERY = 220;
  function fitGallery() {
    var track = $('.pdp-media .product-media-slider .gridy-track');
    var atc = $('.pdp-content .product-block__buy_buttons');
    if (!track || !atc) return;
    var t = track.getBoundingClientRect();
    var a = atc.getBoundingClientRect();
    var below = a.bottom - t.bottom; // buy box height under the gallery, down to Add to cart
    var max = Math.round(window.innerWidth * 0.75 * 1.5);
    var target = Math.floor(window.innerHeight - (t.top + window.scrollY) - below - 8);
    target = Math.max(MIN_GALLERY, Math.min(max, target));
    var current = parseFloat(track.style.getPropertyValue('--mpdp-gallery-h')) || 0;
    if (Math.abs(current - target) > 3) track.style.setProperty('--mpdp-gallery-h', target + 'px');
  }

  /* ---------------- B) sticky ---------------- */

  function syncBuyBarSize() {
    var src = document.getElementById('selectedVariantText');
    var out = $$('[data-buy-bar-size]');
    if (!out.length) return;
    if (!src) { // no size drawer on this product: the bar shows just Add to cart
      $$('.buy-bar-size').forEach(function (btn) { btn.hidden = true; btn.style.display = 'none'; });
      return;
    }
    function write() {
      var full = src.textContent.replace(/\s+/g, ' ').trim();
      var short = full.split(' (')[0]; // "A4 (21 x 30 cm)" -> "A4"
      out.forEach(function (el) {
        if (el.textContent !== short) el.textContent = short;
        var btn = el.closest('.buy-bar-size');
        if (btn) btn.setAttribute('aria-label', full);
      });
    }
    write();
    new MutationObserver(write).observe(src, { childList: true, characterData: true, subtree: true });
    $$('.buy-bar-size').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var opener = document.getElementById('variantSelector');
        if (opener) opener.click();
      });
    });
  }

  /* ---------------- shared: chat bubble ---------------- */

  // Hidden while the size/frame/Add to cart controls are on screen; otherwise it sits
  // above a visible sticky buy bar. Only the closed bubble is touched, never the open chat.
  var CHAT_SEL = 'body > iframe[title="Chat"], #gorgias-chat-container';
  var BUBBLE_MAX = 160;
  var ticking = false;

  function controlsInView(limit) {
    return $$('.pdp-content .product-block__variant_picker, .pdp-content .product-block__frame_selector, .pdp-content .product-block__buy_buttons')
      .some(function (el) {
        var r = el.getBoundingClientRect();
        return r.height > 0 && r.bottom > 0 && r.top < limit;
      });
  }

  function barHeight() {
    var bar = $('product-buy-bar');
    if (!bar) return 0;
    // Use the bar's resting height, not its animated position: the theme slides it in
    // over 0.3s and the bubble must already clear it when it lands.
    var shown = bar.classList.contains('show');
    return shown ? bar.offsetHeight : 0;
  }

  function updateChat() {
    // assets/chat-launcher.js (theme-wide) owns the bubble when it is loaded: hand over.
    if (window.PeletonChatLauncher) { ticking = false; window.PeletonChatLauncher.update(); return; }
    ticking = false;
    if (!phone.matches) return;
    var bar = barHeight();
    var hide = controlsInView(window.innerHeight - bar);
    $$(CHAT_SEL).forEach(function (el) {
      var r = el.getBoundingClientRect();
      var isBubble = r.height > 0 && r.height <= BUBBLE_MAX;
      if (!isBubble) {
        el.classList.remove('mpdp-chat-hidden');
        if (el.style.getPropertyPriority('bottom') === 'important') el.style.removeProperty('bottom');
        return;
      }
      var want = bar + 'px';
      if (el.style.getPropertyValue('bottom') !== want || el.style.getPropertyPriority('bottom') !== 'important') {
        el.style.setProperty('bottom', want, 'important');
      }
      el.classList.toggle('mpdp-chat-hidden', hide);
    });
  }

  function requestChat() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(updateChat); }
  }

  function watchChat() {
    window.addEventListener('scroll', requestChat, { passive: true });
    window.addEventListener('resize', requestChat);
    // The chat script injects its iframe late and rewrites its style when it opens/closes.
    new MutationObserver(requestChat).observe(document.body, { childList: true });
    var seen = new WeakSet();
    setInterval(function () {
      $$(CHAT_SEL).forEach(function (el) {
        if (seen.has(el)) return;
        seen.add(el);
        new MutationObserver(requestChat).observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
        requestChat();
      });
    }, 1000);
    var bar = $('product-buy-bar');
    if (bar) new MutationObserver(requestChat).observe(bar, { attributes: true, attributeFilter: ['class'] });
    requestChat();
  }

  function init() {
    if (!phone.matches) return;
    if (layout === 'compact') {
      collapseFrameSelector();
      addWallChip();
      fitGallery();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitGallery);
      window.addEventListener('orientationchange', function () { setTimeout(fitGallery, 300); });
    }
    if (layout === 'sticky') syncBuyBarSize();
    if (!window.PeletonChatLauncher) watchChat(); // else chat-launcher.js watches everything
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
